var map = {
	"./menu-bg-light.png": "dobM",
	"./menu-bg.png": "CiEe",
	"./menu-cg-light.png": "jOb1",
	"./menu-cg.png": "zP6t",
	"./menu-gl-light.png": "IUkX",
	"./menu-gl.png": "2l4r",
	"./menu-kc-light.png": "LHBH",
	"./menu-kc.png": "25kt",
	"./menu-ml-light.png": "GRS3",
	"./menu-ml.png": "mzSZ",
	"./menu-xs-light.png": "e+aC",
	"./menu-xs.png": "pfbU"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "zaQe";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home ^\.\/menu\-.*\.png$
// module id = zaQe
// module chunks = 2